import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import isoCertificacion from "@images/isoCertification.svg"
import score from "@images/9OutOf10.svg"
import { useBreakpoints } from "@hooks/useBreakpoints"

const OperationalExcellence = ({ theme }) => {
  const { t } = useTranslation()
  const { isDesktop } = useBreakpoints()

  // White by default
  let background = "bg-white"
  let color = "text-[#151124]"

  switch (theme) {
    case "blue-bg":
      background = "bg-dblue"
      color = "text-white"
      break

    case "gray-bg":
      background = "bg-lblue"
      color = "text-dblue"
      break
  }

  return (
    <div
      className={`
      py-[40px]
      px-[24px]
      text-center
      flex
      flex-col
      gap-[36px]


      desk:py-[100px]
      desk:gap-[40px]

      ${color}
      ${background}
    `}
    >
      <div>
        {" "}
        <h2
          className={`
            font-inter
            text-[20px]
            leading-[120%]
            font-medium
         
            desk:text-[40px]
          `}
        >
          {t("Metals_OperationalExcellence")}
        </h2>
      </div>
      <div
        className={`
          flex
          flex-col
          gap-[36px]

          md:flex-row
          md:items-end
          md:justify-center

          desk:gap-[60px]
      `}
      >
        <div
          className={`
          flex 
          flex-col  
          items-center 
          gap-[16px]
          w-[327px]

          desk:w-[552px]
          desk:gap-[24px]
        `}
        >
          <img
            className={`desk:w-fit`}
            src={score}
            style={{
              height: isDesktop ? "80px" : "50px",
            }}
            alt={t("rating_metaloop")}
          />
          <span
            className={`
            text-[14px]
            leading-[normal]
            font-semibold
            font-inter

            desk:text-[20px]
            desk:bold
            uppercase 
        `}
          >
            {t("Metals_RatingText")}
          </span>
        </div>{" "}
        <div
          className={`
          flex 
          flex-col  
          items-center 
          w-[327px]
          gap-[16px]

          desk:w-[552px]
          desk:gap-[24px]

        `}
        >
          <img
            className={`desk:w-fit`}
            src={isoCertificacion}
            style={{
              height: isDesktop ? "120px" : "80px",
            }}
            alt={t("certification_quality management_metaloop")}
          />
          <span
            className={`
            text-[14px]
            leading-[normal]
            font-semibold
            font-inter


            desk:text-[20px]
            desk:bold
            desk:uppercase 
        `}
          >
            {t("AboutMetaloop_Section5_Header2")}
          </span>
        </div>
      </div>
    </div>
  )
}

export default OperationalExcellence
